export function CloseIcon() {
  return (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" className="pointer-events-none h-full w-full">
      <path
        d="M36.3783 11.5766L34.3658 9.54492L22.9616 20.9491L11.5574 9.54492L9.54492 11.5766L20.9491 22.9616L9.54492 34.3658L11.5574 36.3783L22.9616 24.9933L34.3658 36.3783L36.3783 34.3658L24.9741 22.9616L36.3783 11.5766Z"
        fill="#141417"
      />
    </svg>
  );
}
